import React from "react";
import { hydrate } from "react-dom";
import { Router } from "react-router-dom";
import { ensureReady, After, getSerializedData } from "@jaredpalmer/after";
import "./client.scss";
import routes from "./routes";
import Layout from "./Layout";
import history from "./utils/history";
import { initiateStore } from "./stores/provider";
import { StoreProvider } from "easy-peasy";
import ScrollToTop from "./components/ScrollTop/ScrollTop";

const initialStore = getSerializedData("preloaded_state");
const store = initiateStore(initialStore);

ensureReady(routes).then((data) =>
  hydrate(
    <Router history={history}>
      <StoreProvider store={store}>
        <ScrollToTop />
        <Layout>
          <After data={data} routes={routes} />
        </Layout>
      </StoreProvider>
    </Router>,
    document.getElementById("root")
  )
);

if (module.hot) {
  module.hot.accept();
}

export default store;
